import { createAction } from "@ngrx/store";
import { createGetSuccessAction } from "@obg/ngrx-utils";

import { AppError } from "../../app-error/app-error.model";

import { ProductBlock } from "./product-block.model";

export namespace ProductBlockAction {
	const ACTION_PREFIX = "[Product Block]";

	export const get = createAction(`${ACTION_PREFIX} Get`);

	export const getSuccess = createGetSuccessAction(
		createAction(`${ACTION_PREFIX} Get Success`, (products: ProductBlock[]) => ({ products }))
	);

	export const getFail = createAction(`${ACTION_PREFIX} Get Fail`, (error: AppError) => ({ error }));

	export const update = createAction(`${ACTION_PREFIX} Update`, (products: ProductBlock[]) => ({ products }));

	export const updateSuccess = createAction(`${ACTION_PREFIX} Update Success`, (products: ProductBlock[]) => ({
		products,
	}));

	export const updateFail = createAction(`${ACTION_PREFIX} Update Fail`, (error: AppError) => ({ error }));

	export const clear = createAction(`${ACTION_PREFIX} Clear`);
}
